import React from 'react'
import Messages from "./components/Messages"

const App = () => {
  return (
    <div>
      <Messages/>
    </div>
  )
}

export default App  